import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const additionalCollectorQuestion = () => ({
    "collection-agency":{
        header : "Add additional collectors",
        text : ["Do you want to apply for additional collector licences?"],
        navigation : {
            yes : ROUTE_PATH.COLLECTOR_BEFORE_START,
            no : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
        }  
    },
    "debt-management-agency":{
        header : "Add additional debt management agents",
        text : ["Do you want to apply for additional debt management agent licences?"],
        navigation : {
            yes : ROUTE_PATH.COLLECTOR_BEFORE_START,
            no : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
        }  
    },
    "collection-agency-collector" : {
        header : "Add additional collectors",
        text : [
            "Do you want to apply for additional collector licences?"
        ],
        navigation : {
            yes : ROUTE_PATH.COLLECTOR_BEFORE_START,
            no : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
        } 
    },
    "debt-management-agent" : {
        header : "Add additional debt management agents",
        text : [
            "Do you want to apply for additional debt management agent licences?"
        ],
        navigation : {
            yes : ROUTE_PATH.COLLECTOR_BEFORE_START,
            no : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT
        } 
    }
})

const additionalCollectorQuestionSlice = createSlice({
    name : 'additionalCollectorQuestion',
    initialState: additionalCollectorQuestion(),
    reducers: {
        setAdditionalCollectorQuestionAnswer(state, action) {
            state.licenHistoryQuestionAnswer = action.payload
        }
    }
})

export const {setAdditionalCollectorQuestionAnswer} = additionalCollectorQuestionSlice.actions

export default additionalCollectorQuestionSlice.reducer